import type { ComponentType, SVGProps } from 'react';
import { LogoEmblem, LogoFooter, LogoMenuBackground } from '@/components/logos';
import type { UiLogoVariant } from './UiLogo.types';

export const LOGO_COMPONENTS: Record<UiLogoVariant, ComponentType<SVGProps<SVGSVGElement>>> = {
    emblem: LogoEmblem,
    footer: LogoFooter,
    menuBackground: LogoMenuBackground,
};
